/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * SVM API
 * SVM API documentation
 * OpenAPI spec version: 1.0
 */
import type { GetTelemetryPointsParams, PagedResponseTelemetryPointResponse } from '../models';

export type getTelemetryPointsResponse200 = {
    data: PagedResponseTelemetryPointResponse;
    status: 200;
};

export type getTelemetryPointsResponse400 = {
    data: void;
    status: 400;
};

export type getTelemetryPointsResponse500 = {
    data: void;
    status: 500;
};

export type getTelemetryPointsResponseSuccess = getTelemetryPointsResponse200 & {
    headers: Headers;
};

export type getTelemetryPointsResponseError = (
    | getTelemetryPointsResponse400
    | getTelemetryPointsResponse500
) & {
    headers: Headers;
};

export type getTelemetryPointsResponse =
    | getTelemetryPointsResponseSuccess
    | getTelemetryPointsResponseError;

export const getGetTelemetryPointsUrl = (id: string, params?: GetTelemetryPointsParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
        ? `/api/v1/flights/${id}/telemetry-points?${stringifiedParams}`
        : `/api/v1/flights/${id}/telemetry-points`;
};

export const getTelemetryPoints = async (
    id: string,
    params?: GetTelemetryPointsParams,
    options?: RequestInit
): Promise<getTelemetryPointsResponse> => {
    const res = await fetch(getGetTelemetryPointsUrl(id, params), {
        ...options,
        method: 'GET'
    });

    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data = (body !== null ? body : '') as unknown as getTelemetryPointsResponse['data'];

    return { data, headers: res.headers, status: res.status } as getTelemetryPointsResponse;
};
